import styled from 'styled-components';

const FooterWrapper = styled.div`
  margin-top: ${(props): string => props.theme.spaces.xxl};
  text-align: right;
  align-items: center;
`;

export { FooterWrapper };
